import type {StatusBadgeTone} from './StatusBadge';

/**
 * The single status -> tone mapping (audit item #64). Tone is never the only
 * signal: StatusBadge always renders the status text, a tone symbol and
 * screen-reader text. "Overdue", "Urgent" and "Disputed" are danger, not warning.
 * Rules run in order; the first match wins. Unknown text is neutral.
 */
const rules:ReadonlyArray<readonly [StatusBadgeTone,RegExp]>=[
  ['warning',/\bnot (?:yet )?(?:approved|verified|complete(?:d)?|paid|signed|received|confirmed|resolved|accepted)\b/],
  ['unavailable',/\b(archived|inactive|cancel(?:l)?ed|withdrawn|superseded|not recorded|not applicable|unknown|unavailable|none|closed without)\b/],
  ['danger',/\b(overdue|urgent|disputed|dispute|rejected|refused|failed|failure|expired|lapsed|blocked|breach(?:ed)?|critical|revoked|declined|unpaid|non[- ]?compliant|high risk|emergency|error)\b/],
  ['warning',/\b(due soon|due|expiring|pending|awaiting|waiting|needs|required|review|draft|partial(?:ly)?|on hold|at risk|medium risk|incomplete|missing|attention|suggested|proposed|deferred|unconfirmed|provisional)\b/],
  ['success',/\b(complete(?:d)?|approved|active|paid|verified|resolved|current|done|accepted|compliant|confirmed|signed|sent|applied|in date|received|closed)\b/],
  ['information',/\b(open|in progress|scheduled|new|assigned|planned|reviewed|live|submitted|information)\b/],
];

export function toneForStatus(status:string|null|undefined):StatusBadgeTone{
  const text=(status??'').toLowerCase().replace(/[_-]+/g,' ').replace(/\s+/g,' ').trim();
  if(!text)return 'neutral';
  for(const [tone,pattern] of rules)if(pattern.test(text))return tone;
  return 'neutral';
}
